import React, { useState, useEffect, useRef } from 'react'
import style from './index.module.scss'
import LogOut from '../logOut'
import { Radio, Checkbox } from 'antd';
import moment from 'moment'
import type { UploadProps, RadioChangeEvent } from 'antd';
import { Dropdown, message, Modal, MenuProps, Button, Input, Tooltip, Popconfirm, Switch, Upload, Select } from 'antd'
import { ArrowUpOutlined, ArrowDownOutlined, LogoutOutlined, UnorderedListOutlined, FilterOutlined, PlusSquareOutlined, FolderOpenOutlined, CommentOutlined, EyeOutlined, EyeInvisibleOutlined, CloseOutlined, TagOutlined, TagsOutlined, UserOutlined, PicRightOutlined } from '@ant-design/icons'
// import { userModule } from '../../modules/user'
import * as apis from '../../api/user'
import { deepCopy } from '../../util'
import { memosModule } from '../../modules/memos'

import { StorageModule } from '../../modules/storage'
import user_default from '../../static/image/user_default.png'
import MySelf from '../../components/mySelf/index'
import ExecutorList from '../../components/executorList/index'

import me from '../../static/svg/me.svg'
import avatar from '../../static/svg/avatar.svg'
import phone from '../../static/svg/phone.svg'
import lock from '../../static/svg/lock.svg'
import search from '../../static/svg/search.svg'
import EditPassWord from '../../components/mySelf/editPassWord'
import PopCheck from '../../components/mySelf/popCheck'
import UploadImg from '../../components/upload'
import Search from '../../components/search'
import Talk from '../../components/talk'
import DocumentLibrary from '../../components/documentLibrary'
import LableDrawer from '../../components/memos/drawer'

import Themes from './themes'


import myContext from '../../utils/context'
import useStore from '../../store/useStore'
import { getImgUrlById } from '../../util'
import ManList from '../../components/talk/manList'
import comment from './comment.png';
import comment_a from './comment_a.png';

import Chat from '../../components/chat';

interface Props {
    history: any;
}

interface State {
    userInfo: any;
    isView: any;
}

const NavBar = (props: Props) => {


    const [visibleMsg, setVisibleMsg] = useState<boolean>(false);
    const [ikey, setIkey] = useState<string>('');
    const [state, setState] = useState<State>({
        userInfo: {},
        isView: window.location.hash.indexOf('/view') > -1
    });
    const [visibleMy, setVisibleMy] = useState<boolean>(false);
    const [passVisible, setPassVisible] = useState<boolean>(false);
    const [itemInfo, setItemInfo] = useState<any>(null);
    const [phoneVisible, setPhoneVisible] = useState<boolean>(false);
    const [searchVisible, setSearchVisible] = useState<boolean>(false);
    const [talkVisible, setTalkVisible] = useState<boolean>(false);

    const [exitVisible, setExitVisible] = useState<boolean>(false);
    const [themesVisible, setThemesVisible] = useState<boolean>(false);
    const [addThemeVisible, setAddThemeVisible] = useState<boolean>(false);

    const [themesTitle, setThemesTitle] = useState<any>('');
    const [themesFooter, setThemesFooter] = useState<boolean>(false);
    const [subject, setSubject] = useState<any>('');


    const [isUnbind, setIsUnbind] = useState<boolean>(false);
    const [tx, setTx] = useState<any>('');
    const [userInfos, setUserInfos] = useState<any>([]);

    const [jionVisible, setJionVisible] = useState<boolean>(false);
    const [pageType, setPageType] = useState<any>('');

    //控制层级选择的展示
    const [isSelectOpen, setIsSelectOpen] = useState<any>(false);
    const [subjeckPrivate, setSubjeckPrivate] = useState<any>(false);
    const [documentLibraryVisible, setDocumentLibraryVisible] = useState<any>(false);
    const [permissionsList, setPermissionsList] = useState<any>([]);




    const iRef = useRef<any>();
    const inputRef = useRef<any>()
    const themesRef: any = useRef();

    const ContextProps = {
        subject,
        setSubject,
        setAddThemeVisible
    }
    const items: MenuProps['items'] = [
        {
            label: state.userInfo.username + '的账户', key: 'item-1', icon: <><img src={avatar} className='icon_hover mr-10' /></>,
        }, // 菜单项务必填写 key
        { label: (<>上传头像<UploadImg onRefresh={(id) => { onMyselfAvatar(id) }} /></>), key: 'item-2', icon: <><img src={me} className='icon_hover mr-10' /></>, },
        {
            label: (isUnbind ? <div onClick={() => {
                setItemInfo(state.userInfo?.mobileAccounts[0])
            }}>解绑手机</div> : <div onClick={() => {
                setItemInfo(null)
            }}>绑定手机</div>), key: 'item-3', icon: <><img src={phone} className='icon_hover mr-10' /></>,
        },
        { label: (state.userInfo?.hasPassword ? '修改密码' : '设置密码'), key: 'item-4', icon: <><img src={lock} className='icon_hover mr-10' /></>, },
        { label: '退出登录', key: 'item-5', icon: <><LogoutOutlined style={{ fontSize: '14px' }} className='icon_hover mr-10' /></>, },
    ];
    const themes: MenuProps['items'] = [
        { label: '新建主题', key: 'theme-1', icon: <PlusSquareOutlined className='icon_hover mr-10' />, },
        { label: '打开主题库', key: 'theme-2', icon: <FolderOpenOutlined className='icon_hover mr-10' />, },
        { label: '文档库', key: 'theme-4', icon: <FolderOpenOutlined className='icon_hover mr-10' />, },
        { label: '任务视图', key: 'theme-3', icon: <FolderOpenOutlined className='icon_hover mr-10' />, },

    ];
    const [hierarchyMaxOps, setHierarchyMaxOps] = useState<MenuProps['items']>([]);
    const ganttfilter: MenuProps['items'] = [
        { label: '按起止日期', key: 'gantt-1', icon: '', },
        { label: '按执行人', key: 'gantt-2', icon: '', },
    ];

    const { store, dispatch } = useStore();
    const [calendarValue, setCalendarValue] = useState<any>(store.calendarCurTimeType || 'year');
    const [taskCalendarValue, setTaskCalendarValue] = useState<any>(store.taskCalendarCurTimeType || 'day');

    const [subjectValue, setSubjectValue] = useState<any>(store.subjectCurType || 'default');
    const calendarOptions = [
        { value: 'year', label: '年' },
        { value: 'season', label: '季' },
        { value: 'month', label: '月' },
        { value: 'week', label: '周' },
        { value: 'day', label: '日' },
    ];
    const subjeckOptions = [
        { value: 'default', label: '默认', placeholder: "我的全部任务" },
        { value: 'current', label: '本主题', placeholder: "本主题中的全部任务" },
        { value: 'all', label: '全部', placeholder: "现有全部任务" },
    ];
    const calendarOnChange = ({ target: { value } }: RadioChangeEvent) => {
        console.log('radio1 checked', value, store.calendarCurTime)
        setCalendarValue(value)
        StorageModule.set('calendarCurTimeType', value)
        dispatch({
            type: 'SET_CALENDARCURTIMETYPE',
            data: value
        });
        if (value == 'year') {
            window.location.hash = `/calendar/${moment(store.calendarCurTime).format("YYYY-MM-DD")}`
        } else {
            window.location.hash = `/schedule/${value}/${moment(store.calendarCurTime).format("YYYY-MM-DD")}`
        }
    }
    const taskCalendarOnChange = ({ target: { value } }: RadioChangeEvent) => {
        setTaskCalendarValue(value)
        StorageModule.set('calendarCurTimeType', value)
        dispatch({
            type: 'SET_TASKCALENDARCURTIMETYPE',
            data: value
        });
    }
    const subjeckOnChange = ({ target: { value } }: RadioChangeEvent) => {
        console.log('radio1 checked', value,)
        setSubjectValue(value)
        dispatch({
            type: 'SET_SUBJECTCURTYPE',
            data: value
        });
    }
    useEffect(() => {
        state.isView = window.location.hash.indexOf('/view') > -1
        setState(state)

    }, [window.location.hash.indexOf('/view') > -1])
    useEffect(() => {
        let newArr = []
        for (let i = 1; i < store.viewHierarchyInfo?.hierarchyMax + 1; i++) {
            newArr.push({
                key: `level_${i}`,
                label: `${i}级`,
            })
        }
        //层级视图最大层级数
        setHierarchyMaxOps(newArr)
    }, [store.viewHierarchyInfo?.hierarchyMax])

    useEffect(() => {
        const url = new URL(window.location.href.replace('/#', ''));
        const ikey = url.searchParams.get('ikey') || '';
        if (ikey) {
            setIkey(ikey);
        }
    }, [])
    useEffect(() => {
        if (store.executorUserShow) {
            console.log('')
        }
    }, [store.executorUserShow])
    useEffect(() => {
        console.log("navbar路由location.hash")
        let type: any = window.location.hash.slice(2)
        if (type.indexOf('/') >= 0) {
            type = type.slice(0, type.indexOf('/'))
        }
        setPageType(type)
        if (type === 'calendar') {
            setCalendarValue('year')
            StorageModule.set('calendarCurTimeType', 'year')

        } else {
            console.log('走这个', calendarValue)
            setCalendarValue(StorageModule.get('calendarCurTimeType'))
        }
        if (type !== 'memo') {
            dispatch({
                type: 'SET_SUBJECTINFO_PART',
                data: { subjectId: '', comments: [], comment: [], relationBelongTos: [] }
            });
            (window as any).graphItem && (window as any).graphItem.clearCells()
        }

        dispatch({
            type: 'SET_MEMOINFO',
            data: {}
        });
        dispatch({
            type: 'SET_SHOWDRAWLABEL',
            data: false
        });
        dispatch({
            type: 'SET_VIEW_HIERARCHY_INFO',
            data: { ...store.viewHierarchyInfo, chooseLevel: 0 }
        });

        console.log('CALENDARCURTIMETYPE', store.calendarCurTimeType)
    }, [window.location.hash, calendarValue])

    useEffect(() => {
        //便签注释自动聚焦
        if (addThemeVisible) {
            setTimeout(() => {
                inputRef.current.focus({
                    cursor: 'end',
                });
            }, 500);
        }
    }, [addThemeVisible, inputRef])
    useEffect(() => {
        state.userInfo = StorageModule.getUser().user;
        if (state.userInfo.avatar) {
            setTx(state.userInfo.avatar)
        }
        if (state.userInfo?.mobileAccounts?.length > 0) {
            setIsUnbind(true)
        } else {
            setIsUnbind(false)
        }

    }, [StorageModule.getUser().user])
    useEffect(() => {
        if (store.subjectInfo?.data?.permissions) {
            setPermissionsList(store.subjectInfo.data.permissions)
        }
    }, [store.subjectInfo.data])
    useEffect(() => {
        setTx(state.userInfo.avatar)
    }, [state.userInfo.avatar])
    /**
   * @name 修改头像
   */
    const onMyselfAvatar = async (e: any): Promise<any> => {
        try {
            let response: any = await apis.myselfAvatar(e)
            if (response.ok) {
                message.success('修改成功')
                getInfo()
            }
        } catch (err) { }

    }
    /**
     * @name 关闭退出登录弹出框
     */
    const onClick: MenuProps['onClick'] = ({ key }) => {
        switch (key) {
            case 'item-1':
                setVisibleMy(true)
                break;
            case 'item-3':
                setPhoneVisible(true)
                break
            case 'item-4':
                setPassVisible(true)
                break
            case 'item-5':
                setExitVisible(true)
                break
            case 'theme-1':

                setAddThemeVisible(true)
                break
            case 'theme-2':
                setThemesTitle('选择主题')
                setThemesVisible(true)
                setJionVisible(false)
                setThemesFooter(false)
                break
            case 'theme-3':
                window.location.hash = '#/gantt'
                break
            case 'theme-4':
                setDocumentLibraryVisible(true)
                break
            case 'gantt-1':
                dispatch({
                    type: 'SET_GANTTDATE',
                    data: true
                });
                break
            case 'gantt-2':
                dispatch({
                    type: 'SET_EXECUTORUSERSHOW',
                    data: true
                });
                // dispatch({
                //     type: 'SET_GANTTUSER',
                //     data: true
                // });
                break
        }
    };
    const onClickLevel: MenuProps['onClick'] = ({ key }) => {
        console.log(key)
        dispatch({
            type: 'SET_VIEW_HIERARCHY_INFO',
            data: { ...store.viewHierarchyInfo, chooseLevel: Number(key.split("_")[1]) }
        });
    };
    /**
    * @name 获取用户信息
    */
    const getInfo = async (): Promise<void> => {
        try {
            let response: any = await apis.myself()
            state.userInfo = response.data
            setState({ ...state })
            StorageModule.setUser(state.userInfo);
        } catch (err) { }
    }
    /***
     * 下一步
     */
    const subjectNext = () => {
        if (!subject) {
            message.warn('请输入主题名称')
        } else {
            setAddThemeVisible(false)
            setThemesTitle('选择主题分类')
            setThemesVisible(true)
            setJionVisible(false)
            setThemesFooter(true)
        }
    }
    const operationMan = (users: any, type: any) => {
        memosModule.operationMan(users, type, store.subjectInfo.data)
    }


    const Authorization: any = localStorage.getItem('pl_token')
    const exportFile = async () => {
        let base = `${process.env.REACT_APP_SCP}/api/excelling/topic/export`
        // if (window.location.href.indexOf('localhost') > -1) {
        //     base = `${process.env.REACT_APP_SCP}/api/excelling/topic/export`
        // }
        window.open(base + '?Authorization=' + Authorization)
    }


    const uploadImage: any = async (options: any) => {
        const { onSuccess, onError, file, onProgress } = options;
        let formData = new FormData();
        formData.append('data', file);
        try {
            const res = await apis.importFileApi(formData)

            onSuccess(res);
            console.log("server res: ", res);
        } catch (err) {
            console.log("Eroor: ", err);
            const error = new Error("Some error");
            onError({ err });
        }
    };

    const propsOption: UploadProps = {
        name: 'file',
        accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
        customRequest: (options) => uploadImage(options),
        headers: {
            Authorization: Authorization
        },
        showUploadList: false,
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                themesRef.current.getListHandle()
                message.success(`${info.file.name} 导入成功`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} 导入失败`);
            }
        },
    };
    return (
        <div className={style.headout}>
            <div className={style.head} data-flex='main:justify cross:center'>
                <div className={style.logo + ' cursor'} style={{ width: "50%" }} data-flex='main:left cross:center'>
                    <div className='mr-10'>Excelling</div>
                    <div> <Dropdown menu={{ items: themes, onClick }} trigger={['click']}>
                        <UnorderedListOutlined />
                    </Dropdown></div>
                    <>
                        <div className={'ml-10 ' + (pageType == 'view' ? style.curr : style.m18)} style={{ maxWidth: "60%" }} onClick={() => window.location.hash = '#/view'}>
                            {
                                store.subjectInfo?.subjectTitle?.length < 10 ? <div className='clamp1'>{store.subjectInfo?.subjectTitle}</div>
                                    : <Tooltip color={'#fff'} placement="bottom" title={store.subjectInfo?.subjectTitle}
                                        overlayInnerStyle={{ color: "#171A1E" }}
                                        overlayStyle={{ maxWidth: "50%" }}
                                    >
                                        <div className='sl-ellipsis' >{store.subjectInfo?.subjectTitle}</div>
                                    </Tooltip>
                            }
                        </div>
                        {/* <div className={`sl-ellipsis ${style.navItem} ` + (pageType == 'view' ? style.curr : style.m18)} onClick={() => {

                            window.location.hash = '#/view'
                        }}>层级视图</div> */}
                        <div className={`sl-ellipsis ${style.navItem} ` + (pageType == 'memo' ? style.curr : style.m18)} onClick={() => {

                            window.location.hash = '#/memo'
                        }}>便签视图</div>
                        <div className={`sl-ellipsis ${style.navItem} ` + (pageType == 'calendar' || pageType == 'schedule' ? style.curr : style.m18)} onClick={() => {
                            window.location.hash = `#/calendar/${moment(store.calendarCurTime).format("YYYY-MM-DD")}`
                        }}>日历视图</div>
                        <div className={`sl-ellipsis ${style.navItem} ` + (pageType == 'taskKanban' ? style.curr : style.m18)} onClick={() => {
                            window.location.hash = '#/taskKanban'
                        }}>任务看板</div>
                    </>
                    {pageType == 'gantt' && <>
                        <div className='sl-ellipsis ml-10' >任务视图</div>
                    </>}
                </div>
                <div data-flex='main:left cross:center' className='menu'>
                    {
                        pageType == 'view' && <><div className={style.iconLevel}>
                            <Dropdown menu={{ items: hierarchyMaxOps, onClick: onClickLevel }} trigger={['click']}>
                                <PicRightOutlined className='levelBtn icon_hover mr-10'
                                />
                            </Dropdown>

                            {/* <Select className={style.iconLevelSelect}
                                defaultValue={store.viewHierarchyInfo?.chooseLevel}
                                style={{ width: 120 }}
                                open={isSelectOpen}
                                onChange={(e) => {
                                    console.log(e)
                                    dispatch({
                                        type: 'SET_VIEW_HIERARCHY_INFO',
                                        data: { ...store.viewHierarchyInfo, chooseLevel: e }
                                    });
                                }}
                                options={hierarchyMaxOps} /> */}
                        </div>
                        </>
                    }
                    <>
                        {(pageType == 'memo') && <>
                            <>{permissionsList?.find((i: any) => i == 'discussion_create') &&
                                <><div data-flex='main:left cross:center' className={style.userInfos}>
                                    <ManList isShowName={false} limit={5} data={store.subjectInfo.data} showTalkPop={() => setTalkVisible(true)} />


                                    {/*store.subjectInfo.data?.userInfos?.length > 5 &&
                                <Tooltip trigger={['click']} color={'#fff'} placement="bottomRight"
                                    title={
                                        <div data-flex='main:left'>
                                            <div className='toop-user'>
                                                <ManList isShowName={false} excludeLimit={5} showTalkPop={() => setTalkVisible(true)}
                                                    isWap={true} data={store.subjectInfo.data?.userInfos} />
                                            </div>
                                        </div>}
                                    overlayInnerStyle={{ color: "#171A1E" }}
                                    overlayStyle={{ maxWidth: "50%" }}
                                >
                                    <div className={style.userInfos_item}>+<br />{store.subjectInfo.data?.userInfos?.length - 5}</div>
                                </Tooltip>
                                    */}

                                    {store.subjectInfo.data?.userInfos?.length > 0 && state.userInfo?.id === store.subjectInfo.data?.owner?.id && <Popconfirm
                                        placement="leftBottom"
                                        title={'确认解散讨论组？'}
                                        onConfirm={(e: any) => {
                                            e.stopPropagation();
                                            operationMan([], 'deleteAll');
                                            dispatch({
                                                type: 'SET_SHOWCHAT',
                                                data: false
                                            });
                                        }}
                                        okText="确认"
                                        cancelText="取消"
                                    >
                                        <CloseOutlined className='icon_hover mr-5' />
                                    </Popconfirm>
                                    }

                                </div>
                                    {
                                        store.subjectInfo.data?.userInfos?.length > 0 ?
                                            <div className={' icon_hover mr-20'} onClick={() => {
                                                console.log('store.showChat', store.showChat, store.chatDiscussionId,)
                                                dispatch({
                                                    type: 'SET_SHOWCHATTYPE',
                                                    data: 'theme'
                                                });
                                                if (store.showChat) {
                                                    dispatch({
                                                        type: 'SET_SHOWCHAT',
                                                        data: (store.chatDiscussionId) ? true : false
                                                    });
                                                    if (store.chatDiscussionId) {
                                                        dispatch({
                                                            type: 'SET_CHATDISCUSSIONID',
                                                            data: ''
                                                        });
                                                    }
                                                } else {
                                                    if (store.subjectInfo?.data?.memoId) {
                                                        console.log('2')
                                                        dispatch({
                                                            type: 'SET_CHATID',
                                                            data: store.subjectInfo?.data?.memoId
                                                        });
                                                        dispatch({
                                                            type: 'SET_CHATDISCUSSIONID',
                                                            data: ''
                                                        });

                                                        dispatch({
                                                            type: 'SET_SHOWLABLE',
                                                            data: false
                                                        });
                                                        dispatch({
                                                            type: 'SET_CLOSESHOWALL',
                                                            data: ['showChat']
                                                        });
                                                    }
                                                }
                                            }}>
                                                <img className={style.commenticon}
                                                    src={comment}
                                                /> </div> :
                                            <CommentOutlined
                                                onClick={() => {
                                                    setTalkVisible(true)
                                                }} className='icon_hover mr-20'
                                                style={{ fontSize: '18px' }} />
                                    }</>}</>

                            {!store.showNode ? <EyeOutlined onClick={() => {
                                dispatch({
                                    type: 'SET_SHOWNODE',
                                    data: true
                                });
                            }} className='icon_hover mr-20' style={{ fontSize: '18px' }} /> : <EyeInvisibleOutlined className='icon_hover mr-20' onClick={() => {
                                dispatch({
                                    type: 'SET_SHOWNODE',
                                    data: false
                                });
                            }} style={{ fontSize: '18px' }} />}

                            <div className='icon_hover mr-20' onClick={() => {
                                setSearchVisible(true)
                            }}>
                                <img src={search} />
                            </div>

                            {/* trigger={['click']} */}

                        </>}

                        {(pageType == 'calendar' || pageType == 'schedule' || pageType == 'taskKanban') && <div className={'navbarRadio'}>
                            {/* <Radio.Group options={subjeckOptions} onChange={(e) => { subjeckOnChange(e) }} value={subjectValue} optionType="button" /> */}
                            <Radio.Group defaultValue={subjectValue} value={subjectValue} optionType="button" onChange={(e) => { subjeckOnChange(e) }}>
                                {subjeckOptions.map((i: any) => {
                                    return <>
                                        <Tooltip placement="topLeft" title={i.placeholder}>
                                            <Radio.Button value={i.value}>{i.label}</Radio.Button>
                                        </Tooltip></>
                                })}
                            </Radio.Group>
                        </div>}
                        {(pageType == 'calendar' || pageType == 'schedule') && <div className={'navbarRadio'}>
                            <Button className="" onClick={(e) => {
                                dispatch({
                                    type: 'SET_CALENDARCURTIME',
                                    data: moment(new Date()).format("YYYY-MM-DD")
                                });
                            }}>今日</Button>
                            <Radio.Group options={calendarOptions} onChange={(e) => { calendarOnChange(e) }} value={calendarValue} optionType="button" />

                        </div>}
                        {(pageType == 'taskKanban') && <div className={'navbarRadio'}>
                            <Radio.Group options={calendarOptions} onChange={(e) => { taskCalendarOnChange(e) }} value={taskCalendarValue} optionType="button" />
                        </div>}
                        {pageType == 'gantt' && <>
                            <Dropdown menu={{ items: ganttfilter, onClick }} trigger={['click']}>
                                <FilterOutlined className='icon_hover mr-20' style={{ fontSize: '18px' }} />
                            </Dropdown>
                        </>}
                        {(pageType == 'schedule' || pageType == 'calendar' || pageType == 'taskKanban') && <>
                            <UserOutlined className='icon_hover mr-20' onClick={() => {
                                dispatch({
                                    type: 'SET_EXECUTORUSERSHOW',
                                    data: true
                                });
                            }} style={{ fontSize: '18px' }} />
                        </>}
                        {(pageType == 'memo' || pageType == 'schedule' || pageType == 'view' || pageType == 'taskKanban') && <>
                            {!store.showLable ? <TagOutlined onClick={() => {
                                dispatch({
                                    type: 'SET_CLOSESHOWALL',
                                    data: ['showLable']
                                });
                            }} className='icon_hover mr-20' style={{ fontSize: '18px' }} /> : <TagsOutlined className='icon_hover mr-20' onClick={() => {
                                dispatch({
                                    type: 'SET_CLOSESHOWALL',
                                    data: null
                                });
                            }} style={{ fontSize: '18px' }} />}
                        </>}
                    </>


                    <Dropdown menu={{ items, onClick }} trigger={['click']}>

                        <div className={'user_default' + ' cursor'} onClick={e => e.preventDefault()}>

                            {
                                state.userInfo?.avatar ?
                                    <img alt="" className={'user_default'} src={getImgUrlById(tx)} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} />

                                    :
                                    <img alt="" className={'user_default'} src={user_default} />
                            }
                        </div>
                    </Dropdown>
                </div>

            </div>
            {/* 退出登录弹出框 */}
            <myContext.Provider value={ContextProps}>

                <LogOut visible={exitVisible} onClose={() => setExitVisible(false)} />
                <MySelf visible={visibleMy} onClose={() => { setVisibleMy(false) }} />
                <EditPassWord userInfo={state.userInfo} visible={passVisible} onClose={() => setPassVisible(false)} onRefresh={() => { getInfo() }} />
                <PopCheck title={itemInfo ? '解绑手机' : '绑定手机'} type={'mobile'} info={itemInfo} visible={phoneVisible} onRefresh={() => { getInfo() }} onClose={() => { setPhoneVisible(false); setItemInfo(null) }} />
                <Search title={''} visible={searchVisible} onRefresh={() => { }} onClose={() => { setSearchVisible(false); }} />
                <Talk title={''} visible={talkVisible} onRefresh={() => { }} onClose={() => { setTalkVisible(false); }} />

                <Themes ref={themesRef} onRefresh={() => { }} subjeckPrivate={subjeckPrivate} isJion={jionVisible} isFooterButton={themesFooter} title={<div data-flex='main:justify cross:center'>

                    <div className='mr-30' data-flex='main:left cross:center'>
                        <div className={style.icon_btn} onClick={exportFile}><ArrowUpOutlined />导出</div>
                        <Upload {...propsOption}>
                            <div className={style.icon_btn}><ArrowDownOutlined />导入</div>
                        </Upload>

                        <Switch checked={jionVisible} onChange={(e) => {
                            setJionVisible(e)
                            setThemesTitle(e ? '讨论中的主题' : '选择主题')
                        }} />
                        <div className='ml-5'>讨论中的主题</div>
                    </div>
                </div>} visible={themesVisible} onClose={(e) => {
                    if (e === 'clearCheck') {
                        setSubjeckPrivate(false)
                    }
                    setThemesVisible(false);
                    if (themesFooter) {
                        setAddThemeVisible(true)
                    }
                }} />
                <Modal
                    onCancel={() => {
                        setAddThemeVisible(false)
                        setSubject('')
                        setSubjeckPrivate(false)
                    }}
                    title={'新建主题'}

                    width={'50%'}
                    footer={[<><Checkbox key='btn' checked={subjeckPrivate} onChange={(e) => { setSubjeckPrivate(e.target.checked) }}>私有</Checkbox><Button className='btn ' key='btn1' type="primary" onClick={() => {
                        subjectNext()
                    }}>下一步</Button></>]}
                    open={addThemeVisible}>
                    <div>
                        <Input placeholder="请输入主题名称" ref={inputRef} value={subject} onChange={(e) => {
                            setSubject(e.target.value)
                        }} onPressEnter={() => { subjectNext() }} />
                    </div>
                </Modal>
                <ExecutorList visible={store.executorUserShow} type={pageType} onClose={() => {
                    dispatch({
                        type: 'SET_EXECUTORUSERSHOW',
                        data: false
                    });
                }} />
            </myContext.Provider>
            <Chat onClose={() => {
                dispatch({
                    type: 'SET_SHOWCHAT',
                    data: false
                });
            }} />
            <LableDrawer onClose={() => {
                dispatch({
                    type: 'SET_SHOWDRAWLABEL',
                    data: false
                });
            }} />
            <DocumentLibrary visible={documentLibraryVisible} onClose={() => { setDocumentLibraryVisible(false) }} />
        </div >
    )
}

export default NavBar